import React from 'react';
import { Image } from '@chakra-ui/react';
import siesa1 from '../../img/siesa1-480.webp';
import logo2 from '../../img/logo2.png';
import logoSimple from '../../img/logoSimple.png';
import logoSolo from '../../img/logoSolo-160.webp';

const LOGO_SOURCES = {
  navbar: siesa1,
  footer: logo2,
  mark: logoSolo,
  default: logoSimple,
};

const INTRINSIC_SIZE_BY_SRC = {
  [siesa1]: { width: 480, height: 320 },
  [logo2]: { width: 584, height: 623 },
  [logoSimple]: { width: 250, height: 61 },
  [logoSolo]: { width: 160, height: 161 },
};

/**
 * Componente centralizado para la identidad de marca de SIESA.
 * - variant="navbar": Usa siesa1.png (logo principal destacado para el header)
 * - variant="footer": Usa logo2.png (para el pie de página)
 * - variant="mark": Usa logoSolo (isotipo sin texto, para acompañar al wordmark)
 * - Por defecto: Usa logoSimple.png
 */
export default function SiesaLogo({
  variant = 'darkOnLight',
  src,
  alt = 'SIESA',
  w,
  h,
  maxH,
  htmlWidth,
  htmlHeight,
  loading,
  fetchPriority,
  ...props
}) {
  const logoSrc = src || LOGO_SOURCES[variant] || LOGO_SOURCES.default;
  const intrinsicSize = INTRINSIC_SIZE_BY_SRC[logoSrc];
  const effectiveLoading =
    loading || (variant === 'footer' ? 'lazy' : undefined);
  const effectiveFetchPriority =
    fetchPriority ||
    (variant === 'navbar' || variant === 'mark' ? 'high' : undefined);

  return (
    <Image
      src={logoSrc}
      alt={alt}
      htmlWidth={htmlWidth || intrinsicSize?.width}
      htmlHeight={htmlHeight || intrinsicSize?.height}
      w={w || 'auto'}
      h={h || 'auto'}
      maxH={maxH}
      loading={effectiveLoading}
      fetchpriority={effectiveFetchPriority}
      objectFit="contain"
      {...props}
    />
  );
}
